import { GIGYA_API_KEYS } from './constants.js';

const gigyaApiKey = ((hostname, window) => {
  let apiKey = window.gigyaApiKey;
  if (!apiKey) {
    apiKey = GIGYA_API_KEYS.raiPlay;
    if (/-(dev|pre|int)\.rai\.it$/g.test(hostname)) {
      apiKey = '3_j85AJRao6Juhh_I_gponGAA4oGNKjFhtAvBw3slTTfCgfn0lMwZzweBE865vDZEZ';
    } else if (/^www\.(rairadio|radiorai|raiplayradio|raiplaysound)\.it$/.test(hostname)) {
      apiKey = GIGYA_API_KEYS.radio;
    } else if (/raisport\.rai\.it$/.test(hostname)) {
      apiKey = GIGYA_API_KEYS.raiSport;
    } else if (/sttest\.rai\.it$/.test(hostname)) {
      apiKey = GIGYA_API_KEYS.stTest;
    } else if (/^www\.rai\.tv$/.test(hostname)) {
      apiKey = GIGYA_API_KEYS.raiTv;
    } else if (/\.rai\.it$/.test(hostname)) {
      apiKey = GIGYA_API_KEYS.rai;
    }
    window.gigyaApiKey = apiKey;
  }
  return apiKey;
})(document.location.hostname, window);

const URL_JS_SOCIALIZE = `//cdns.gigya.com/js/socialize.js?apiKey=${gigyaApiKey}`;

export function initGigyaSDK(document: Document, window: Window, loadedFn: (this: GlobalEventHandlers, ev: Event) => void) {
  if (!('gigya' in window) || !window.gigya) {
    if (!document.body.classList.contains('iframe') && !document.body.classList.contains('video')) {
      (function(d, s: 'script', id){
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)){ return; }
        const js = d.createElement(s) as HTMLScriptElement;
        js.id = id;
        js.onload = loadedFn || function(){
          // remote script has loaded
        };
        js.src = `${URL_JS_SOCIALIZE}&lang=it`;
        fjs?.parentNode?.insertBefore(js, fjs);
      }(document, 'script', 'gigya-sdk'));
    }
  }
}
